import { PERIOD_SPACING } from "./timeline-constants";
import type {
  ScrollHintState,
  TimelineViewportState,
} from "./timeline-root-types";

export const EMPTY_SCROLL_HINT_STATE: ScrollHintState = {
  showLeft: false,
  showRight: false,
};

export const EMPTY_VIEWPORT_STATE: TimelineViewportState = {
  scrollLeft: 0,
  scrollTop: 0,
  width: 0,
  height: 0,
};

export function selectScrollHintStateFromNode(input: {
  scrollContainerNode: HTMLDivElement;
}): ScrollHintState {
  return {
    showLeft: input.scrollContainerNode.scrollLeft > 1,
    showRight:
      input.scrollContainerNode.scrollLeft +
        input.scrollContainerNode.clientWidth <
      input.scrollContainerNode.scrollWidth - 1,
  };
}

export function selectTimelineViewportStateFromNode(input: {
  scrollContainerNode: HTMLDivElement;
}): TimelineViewportState {
  return {
    scrollLeft: input.scrollContainerNode.scrollLeft,
    scrollTop: input.scrollContainerNode.scrollTop,
    width: input.scrollContainerNode.clientWidth,
    height: input.scrollContainerNode.clientHeight,
  };
}

export function areScrollHintStatesEqual(input: {
  previous: ScrollHintState;
  nextState: ScrollHintState;
}): boolean {
  return (
    input.previous.showLeft === input.nextState.showLeft &&
    input.previous.showRight === input.nextState.showRight
  );
}

export function areTimelineViewportStatesEqual(input: {
  previous: TimelineViewportState;
  nextState: TimelineViewportState;
}): boolean {
  return (
    input.previous.scrollLeft === input.nextState.scrollLeft &&
    input.previous.scrollTop === input.nextState.scrollTop &&
    input.previous.width === input.nextState.width &&
    input.previous.height === input.nextState.height
  );
}

export function selectCenteredPeriodIndexFromNodes(input: {
  innerNode: HTMLDivElement;
  scrollContainerNode: HTMLDivElement;
}): number {
  const containerRect = input.scrollContainerNode.getBoundingClientRect();
  const innerRect = input.innerNode.getBoundingClientRect();
  const viewportCenterX =
    containerRect.left + input.scrollContainerNode.clientWidth / 2;
  const centerXInInner = viewportCenterX - innerRect.left;

  return Math.max(
    0,
    Math.round((centerXInInner - PERIOD_SPACING / 2) / PERIOD_SPACING),
  );
}

export function selectTimelinePeriodScrollLeft(input: {
  periodNode: HTMLDivElement;
  scrollContainerNode: HTMLDivElement;
}): number {
  const containerRect = input.scrollContainerNode.getBoundingClientRect();
  const periodRect = input.periodNode.getBoundingClientRect();
  const periodCenterInViewport =
    periodRect.left + periodRect.width / 2 - containerRect.left;

  return Math.max(
    0,
    input.scrollContainerNode.scrollLeft +
      periodCenterInViewport -
      input.scrollContainerNode.clientWidth / 2,
  );
}
